import { useState } from 'react'
import { RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'

export default function PaymentOptions(props) {
  const [selected, setSelected] = useState({});

  const handleChange = (selected) => {
    if (!props.readonly) {
      setSelected(selected);
      props.onChange(selected);
    }
  }

  return (
    <div className="w-full my-4">
      <div className="mx-auto w-full max-w-md">
        <RadioGroup value={selected} onChange={handleChange}>
          <RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
          <div className="space-y-2 ">
            {props.plan.map((plan) => (
              <RadioGroup.Option
                key={plan.pg_code}
                value={plan}
                className={({ active, checked }) =>
                  `${active
                    ? 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-amber-300'
                    : ''
                  }
                  ${checked ? 'bg-amber-200 bg-opacity-75' : 'bg-white'
                  }
                    relative text-gray-800 bg-white flex cursor-pointer rounded-lg px-5 py-4 border border-gray-200 rounded-xl focus:outline-none `
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="flex w-full items-center justify-between">
                      <div className="flex items-center">
                        <div className="text-sm">
                          <RadioGroup.Label
                            as="p"
                            className="text-gray-700 font-semibold"
                          >
                            {plan.pg_name}
                          </RadioGroup.Label>
                        </div>
                      </div>
                      {/* {checked && ( */}
                      <div className="shrink-0 ">
                        {checked ?
                          <CheckCircleIcon className="h-6 w-6 text-amber-500" />
                          :
                          <CheckCircleIcon className="h-6 w-6 text-gray-300" />
                        }
                      </div>

                      {/* )} */}
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
    </div>
  )
}


